import TextTruncate from './textTruncate';
export default TextTruncate;
